class UserController {
    constructor($scope, $http, $state, $stateParams,$translate, AppConfig, $timeout, message, $transitions, Restangular, crc32) {
        "ngInject";

        $scope.errors = {};
        $scope.loading = false;
        $scope.user = this.appUser||{};
        $scope.$state = $state;
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$translate = $translate;

        $scope.captchaUrlBase = AppConfig.server_url + '/captcha';
        $scope.captchaUrl = $scope.captchaUrlBase + '?s=' + Math.random();

        $scope.rememberMe = true;
        $scope.toggleRememberMe = () => {
            $scope.rememberMe = !$scope.rememberMe;
        };

        $scope.agreeTerms = false;
        $scope.toggleAgreeTerms = () => {
            $scope.agreeTerms = !$scope.agreeTerms;
        };

        let self = this;

        $transitions.onEnter({}, () => {
            $scope.errors = {};
        });

        $scope.login = function () {

            if (!validate(['email', 'password'])) {
                return;
            }

            let email = $('#email').val().trim();
            let password = $('#password').val();
            let captcha = $('#captcha').val();
            let remember = $scope.rememberMe ? 1 : 0;

            apiCall('/login', {
                'email': email,
                'password': password,
                'remember': remember,
                'captcha': captcha,
                'crc32': "" + crc32.crc32_str(email + password + remember)
            }, function (user) {
                window.localStorage.setItem("loginUser",JSON.stringify(user));
                self.updateAppUser(user);
            });
        };

        $scope.register = function () {
            if (!validate(['email', 'pseudonym', 'password'])) {
                return;
            }

            if (!$scope.agreeTerms) {
                self.$translate('face-user-text007').then((translation) =>{
                    message.error(translation);
                });
                return;
            }

            let email = $('#email').val();
            let pseudonym = $('#pseudonym').val();
            let password = $('#password').val();

            apiCall('/register', {
                'email': email,
                'pseudonym': pseudonym,
                'password': password,
                'crc32': "" + crc32.crc32_str(email + pseudonym + password)
            }, function (user) {
                self.updateAppUser(user);
            });
        };

        $scope.forget = function () {
            if (!validate(['email', 'captcha'])) {
                return;
            }

            let email = $('#email').val();
            let captcha = $('#captcha').val();

            apiCall('/password/forget', {
                'email': email,
                'captcha': captcha,
                'crc32': "" + crc32.crc32_str(email)
            }, function () {
                $scope.user = {
                    'email': email
                };

                $state.go('app.face.index.user.find');
            });
        };

        $scope.reset = () => {

            let token = $stateParams.s;

            if (!token) {
                self.$translate('face-user-text008').then((translation) =>{
                    message.error(translation);
                });
                return;
            }

            if (!validate(['password', 'password_confirm'])) {
                return;
            }

            let password = $('#password').val();
            let passwordConfirm = $('#password_confirm').val();

            if (password != passwordConfirm) {
                self.$translate('face-user-text009').then((translation) =>{
                    $scope.errors['password_confirm'] = translation;
                });
                return;
            }

            apiCall('/password/reset', {
                'password': password,
                'token': token,
                'crc32': "" + crc32.crc32_str(password + token)
            }, () => {
                $state.go('app.home.dashboard');
            });
        };

        $scope.resend = function () {
            apiCall('/email/confirmation/resend', {},
                () => {
                    self.$translate('face-user-text010').then((translation) =>{
                        message.success(translation);
                    });
                },
                (response) => {
                    message.error(response.data);
                }
            );
        };
        $scope.emailCheck = function () {

            if (!validate(['email'])) {
                return;
            }
            let email = $('#email').val();

            apiCall('/password/status', {
                'email': email
            }, function (res) {
                if(res.data && res.data.need_change_password==1){
                    self.$translate('face-user-text011').then((translation) =>{
                        $scope.errors['email'] = translation;
                    });
                }
            });

            Restangular.one('email/status').get({
                email: email
            }).then(res => {
                if (res.status.code !== 200) {
                    $scope.errors['email'] = res.status.message.email[0];
                }
            })
        };
        $scope.getEmailAddress = function () {
            if ($scope.user) {
                if((/^.*@hotmail|outlook\./).test($scope.user)){
                    return 'https://outlook.live.com/owa/';
                }
                return 'http://' + $scope.user.email.replace(/^.*@/, 'mail.');
            }
            return '';
        };

        $scope.reloadCaptcha = function () {
            $scope.captchaUrl = $scope.captchaUrlBase + '?s=' + Math.random();
        };

        $scope.searchArticle = function () {
            let text = $('#index-search-input').val();

            if (text !== '') {
                $state.go('app.page.search.article', {q: text});
            }
        };

        $scope.searchImage = function () {
            let text = $('#index-search-input').val();

            if (text !== '') {
                $state.go('app.page.search.image', {q: text});
            }
        };
        $scope.bind=function(name) {
            location.href = AppConfig.server_url + "/media/bind/" + name + '?return=/home/import/weixin';
        }

        function apiCall(endpoint, data, successCallback, errorCallback) {
            $scope.loading = true;

            $http.post(AppConfig.server_url + endpoint, data, {
                withCredentials: true
            }).then(

                function success(response) {
                    $scope.loading = false;
                    successCallback(response.data);
                },
                function error(response) {

                    if (typeof(errorCallback) == 'function') {
                        errorCallback(response);
                    } else {
                        if (response.data) {
                            retrieveErrors(response.data);
                        }
                    }

                    $scope.reloadCaptcha();

                    $scope.loading = false;
                }

            );
        }

        function validate(fields) {
            let hasError = false;
            $scope.errors = {};

            for (let i = 0, l = fields.length; i < l; i++) {
                let field = fields[i];
                let inputElement = $('#' + field);

                let value = inputElement.val().trim();
                if (value == '') {
                    self.$translate('face-user-text012').then((translation) =>{
                        $scope.errors[field] = inputElement.data('localeName') + ' ' + translation;
                    });
                    hasError = true;
                }
            }
            if (self.form && self.form["password"].$error.pwdStrength) {
                self.$translate('face-user-text013').then((translation) =>{
                    $scope.errors['password'] = translation;
                });
                hasError = true;
            }

            if (self.form && self.form["email"] && self.form["email"].$error.email) {
                hasError = true;
            }

            return !hasError;
        }

        function retrieveErrors(data) {
            for (let field in data) {
                if (data.hasOwnProperty(field)) {
                    $scope.errors[field] = data[field][0];
                }
            }
        }

        this.checkUserStatus();
    }


    $onInit () {
        this.$timeout(() => {
            if (this.appUser) {
                this.updateAppUser(this.appUser);
            }
        }, 1000)
    }

    checkUserStatus() {

        let self = this;
        if (this.$scope.user && this.$scope.user.id) {

            if (this.$state.is('app.face.index.user.form.reset')) {

                // Password reset takes the first priority
                return false;
            }

            if (!this.$scope.user.email_verified) {
                this.$timeout(() => {
                    self.$state.go('app.face.index.user.confirm');
                });

                return false;
            }

            return true;
        }

        return false;
    }

    updateAppUser(user) {
        let self = this;
        for (let k in user) {
            if (user.hasOwnProperty(k)) {
                this.$scope.user[k] = user[k];
            }
        }
        if (this.checkUserStatus()) {

            if (this.$state.is('app.face.index.user.form.login')) {
                if (this.$stateParams.return) {
                    location.href = this.$stateParams.return;
                } else {
                    this.$timeout(() => {
                        self.$state.go('app.home.dashboard');
                    });
                }
            }
        }
    }
}

export default UserController;



// WEBPACK FOOTER //
// ./src/app/components/face/index/user/user.controller.js